/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */

import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-http-backend";
//import LanguageDetector from "i18next-browser-languagedetector";
// not like to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

const buildNo = process.env.REACT_APP_BUILD_NO;
const cdnDomain = process.env.REACT_APP_ASSETS_URL;

// Base URL for locales on Akamai
const localesBaseUrl = `${cdnDomain}/wcs/storeWeb/statics/${buildNo}/locales/{{lng}}/{{ns}}.json`;

i18n
  // load translation using xhr -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  //.use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    backend: {
      // path where resources get loaded from, or a function
      // returning a path:
      // function(lngs, namespaces) { return customPath; }
      // the returned path will interpolate lng, ns if provided like giving a static path
      loadPath:
        localesBaseUrl && process.env.NODE_ENV === "production"
          ? localesBaseUrl
          : process.env.PUBLIC_URL
          ? `${process.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json`
          : "/locales/{{lng}}/{{ns}}.json",
    },

    fallbackLng: {
      default: ["fr-FR"],
    },
    lng: "fr-FR",
    //debug: true,
    load: "currentOnly",

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
